import React from 'react';
import scaleSize from '../../utils/scale-size';
import styled from 'styled-components/macro';

const Svg = styled.svg`
  margin-bottom: -${scaleSize(5)}px;
`;

export default () => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={scaleSize(32)} height={scaleSize(32)} viewBox="0 0 32 32">
    <path
      fill="#E8B30D"
      stroke="#E8B30D"
      fillRule="evenodd"
      strokeWidth="3"
      d="M15.977 28.05c6.464-5.397 10.695-9.577 12.658-12.47 2.755-4.063 2.398-8.89-.68-12.116C25.253.631 20.22.929 17.01 3.969l-1.031.978-1.032-.977C11.732.926 6.814.63 4.111 3.464c-3.11 3.26-3.524 8.087-.793 12.115 1.962 2.893 6.193 7.073 12.659 12.471z"
    />
  </Svg>
);
